import { render, staticRenderFns } from "./ModalGoogleSignin.vue?vue&type=template&id=16ddf1f4&scoped=true&"
import script from "./ModalGoogleSignin.vue?vue&type=script&lang=js&"
export * from "./ModalGoogleSignin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ddf1f4",
  null
  
)

export default component.exports